import { IAttendancesVotes, SubmitPlayerGameVotesPayload } from "./../../../";
import server from "../Server";
import withErrorCheck from "../CheckError";

export const SubmitPlayerGameVotes = async (
  payload: SubmitPlayerGameVotesPayload
): Promise<Partial<IAttendancesVotes[]>> => {

  const votes: Partial<IAttendancesVotes[]> = [];
  
  for (let i = 0; i < payload.votes.length; i++) {
    // First, try to find existing vote
    const existingVote = withErrorCheck(
      await server
        .from("GameAttendanceVotes")
        .select("*")
        .eq("player_id", payload.votes[i].id)
        .eq("game_attendance_id", payload.votes[i].attendanceId)
        .eq("type", payload.votes[i].type)
        .maybeSingle()
    );

    let result;
    if (existingVote) {
      // Update existing vote
      result = withErrorCheck(
        await server
          .from("GameAttendanceVotes")
          .update({
            type: payload.votes[i].type,
            player_id: payload.votes[i].id,
            game_attendance_id: payload.votes[i].attendanceId,
          })
          .eq("id", existingVote.id)
          .select()
      )[0];
    } else {
      // Insert new vote
      result = withErrorCheck(
        await server
          .from("GameAttendanceVotes")
          .insert({
            type: payload.votes[i].type,
            player_id: payload.votes[i].id,
            game_attendance_id: payload.votes[i].attendanceId,
          })
          .select()
      )[0];
    }
    votes.push(result);
  }

  return votes;
};
